import { throwError, Observable, of, forkJoin } from 'rxjs';
import { catchError, map, tap, flatMap, take, switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { PaginationDTO } from '../app/api/PaginationModel';
import {
  TaskDTO, ProcedureDTO, AuditTaskDTO, UserDTO, DocumentDTO, FileDetailsDTO, DocumentVersionDTO, AttributeDTO,
  MasterDataDTO, Link, SignatureDTO, ActionDTO, DownloadableDTO, TmpFileDTO, OrganizationalUnitDTO, TenderDTO,
  MemberProcurementCommitteeDTO, DivisionDTO, TenderEvaluationCommitteeDTO, IObjectDTO, TemplateDTO, ProcurementCommitteeDTO,
  getSimpleIdentifierFromString, LinkedActionsDTO, BlobFileDetails, ProcurementProjectDefinitionsDTO, getParentIdentifierFromString
} from '../app/api/plyca-dtos';
import { Configuration } from '../app/conf/app.constants';
import { InterfaceSettings, MasterData } from '../app/api/contract-notice-dto';
import { saveAs } from 'file-saver';
import {
  ValidationDTO, ValidationResultDTO, ConfigurationDTO, AccountingDocumentDTO, ActionDefinitionDTO, ActionResultDTO,
  ProcurementProjectDTO, EventAuditDTO, AudMessageDTO, EventAuditStatisticDTO, LogDTO, TimerDTO, LicenseDTO, ReceiveNotifsDTO, SessionDTO,
  RuleDTO, AwardDTO, ReportDTO, CircuitoDTO, EnvelopeDocumentDTO, ProcurementProjectLotDTO, MilestoneDTO, ValidationExecutionDTO,
  ContractModificationDTO, TimerStatusTypeDTO, CircuitFilterModeDTO, ContractDTO, RegisterContractModificationDTO,
  ContractOrganizationalInfoDTO,
  ContractPlannedPeriodDTO, ExportProcessDTO, ExportProcessConfigurationDTO, ContractLotDTO, ObjectContextDTO, ResultTypeDTO, CompanyProjectDTO
} from '../app/api/plyca-dtos-v2';
import {
  HttpClient,
  HttpHeaders,
  HttpResponse,
  HttpErrorResponse,
  HttpParams
} from '../../node_modules/@angular/common/http';
import { FormService } from '../app/components/forms/form.service';
import { ServiceLocator } from '../app/ServiceLocator';
import { TranslateService } from '@ngx-translate/core';
import { BaseProjectEntityDTO, BugdetaryBreakdownDTO, OrderPlannedPeriodDTO, OrderProjectDTO } from '../app/api/sarga-dtos';

@Injectable()
export class PlycaDataService {

  private formService: FormService;
  private translationService: TranslateService;

  constructor(
    private _http: HttpClient,
    private _configuration: Configuration
  ) {
    this.formService = ServiceLocator.injector.get(FormService);
    this.translationService = ServiceLocator.injector.get(TranslateService);

    // OJO: _configuration en este punto es undefined
    // Debido a que ese componente se carga después de este
    // Situación asociada al cambio: PLP.EXP-9889 - Posibilidad de parametrizar el contexto de la aplicación
  }

  public getDossiersWithParams = (
    listadocNombre: string,
    params: string,
    expansion?: string,
    useLastPendingTask?: boolean,
    generateCSV?: boolean
  ): Observable<any> => {
    let url =
      this.getDossierActionURL() +
      '?name=' +
      listadocNombre +
      (params !== '' ? '&' + params : '');

    if (expansion == null) {
      url =
        url +
        '&expand=division,division.procedure,modoTramitacion,claseExpId,phase,expEstado,estado,tipoExpteId,fAdjId';
    } else {
      url = url + expansion;
    }

    if (useLastPendingTask) {
      url += ',lastPendingTask';
    }
    if (!generateCSV) {
      return this._http
        .get<PaginationDTO<any>>(url)
        .pipe(catchError(error => this.handleError(error)));
    } else {
      return this.getCSVFromService(url, 'dossiers').pipe(
        catchError(error => this.handleError(error))
      );
    }
  };

  // public getCSVDossiers(
  //   listadocNombre: string,
  //   params: string,
  //   expansion?: string,
  //   useLastPendingTask?: boolean
  // ) {
  //   let url =
  //     this.getDossierActionURL() +
  //     '?name=' +
  //     listadocNombre +
  //     (params !== '' ? '&' + params : '');

  //   if (expansion == null) {
  //     url =
  //       url +
  //       '&expand=division,division.procedure,modoTramitacion,claseExpId,phase,expEstado,estado,tipoExpteId,fAdjId';
  //   } else {
  //     url = url + expansion;
  //   }

  //   if (useLastPendingTask) {
  //     url += ',lastPendingTask';
  //   }
  //   // console.log( 'URL: ' + url );
  //   return this.getCSVFromService(url, 'dossiers')
  //     .pipe(catchError(error => this.handleError(error)));
  // }

  public getDossiers = (
    listadocNombre: string
  ): Observable<PaginationDTO<any>> => {
    return this.getDossiersWithParams(listadocNombre, '');
  };

  public getFavouriteDossiers = (
    userid: string
  ): Observable<PaginationDTO<any>> => {
    let url =
      this._configuration.URL_BASE + this._configuration.FAVOURITE_SERVICE_URL;
    return this._http
      .get<PaginationDTO<any>>(url + userid + '?page=0&size=10')
      .pipe(catchError(error => this.handleError(error)));
  };

  public getLastAccessedDossiers = (
    userid: string
  ): Observable<PaginationDTO<any>> => {
    let url =
      this._configuration.URL_BASE +
      this._configuration.LASTACCESSED_SERVICE_URL;
    return this._http
      .get<PaginationDTO<any>>(url + userid + '?page=0&size=10')
      .pipe(catchError(error => this.handleError(error)));
  };

  public getDossier = (propuestaId: string, expansion?: string): Observable<any> => {
    let url = this.getDossierActionURL() + '/' + propuestaId;
    if (expansion) {
      url += '?expand=' + expansion;
    }
    return this._http.get<any>(url);
  };

  public getDossiersSearchSetting = (
    listadocNombre: string
  ): Observable<any> => {

    return this._http
      .get<any>(this._configuration.URL_BASE + this._configuration.SEARCH_SETTINGS_FILE_SERVICE_URL + listadocNombre)
      .pipe(catchError(error => this.handleError(error)));
  };

  public getDossierDivisions = (
    dossierId: string,
    expandStr?: string
  ): Observable<PaginationDTO<DivisionDTO>> => {


    let parameters = {};

    if (expandStr) {

      parameters = {
        params: {
          expand: expandStr
        }
      };
    }


    let url =
      this._configuration.ServerWithUserApiUrl +
      'dossiers/' +
      dossierId +
      '/divisions';
    return this._http
      .get<PaginationDTO<DivisionDTO>>(url, parameters)
      .pipe(catchError(error => this.handleError(error)));
  };

  private getAttributesUrl(): any {
    return this._configuration.ServerWithUserApiUrl + 'attributes/';
  }

  private getDossierActionURL(): any {
    return this._configuration.ServerWithUserApiUrl + 'dossiers';
  }

  public downloadEmbedded(fileItem: FileDetailsDTO): Observable<void> {
    return this.download(fileItem, true);
  }

  public downloadFile(fileItem: FileDetailsDTO): Observable<void> {
    return this.download(fileItem, false);
  }

  private download(
    fileItem: FileDetailsDTO,
    embedded: boolean
  ): Observable<any> {
    if (fileItem && (fileItem instanceof BlobFileDetails)) {
      return of((<BlobFileDetails>fileItem).fileContent)
        .pipe(
          tap((blob: Blob) => saveAs(blob, fileItem.name)),
          catchError(error => this.handleError(error))
        );
    } else {
      let links: Link[];
      links = fileItem.download.links;

      let url = links[0].href;
      let fileName = fileItem.name;
      if (embedded) {
        url = url + '?embedded=true';
      } else {
        if (fileItem.nameWithSignatures) {
          fileName = fileItem.nameWithSignatures;
        }
      }
      console.log('downloadFile ', url);
      return this._http
        .get(url, {
          headers: new HttpHeaders({
            Accept: '*/*'
          }),
          responseType: 'blob'
        })
        .pipe(
          tap((blob: Blob) => saveAs(blob, fileName)),
          catchError(error => this.handleError(error))
        );
    }
  }

  public downloadTmpIvan(fileItem: FileDetailsDTO): Observable<void> {
    let url = fileItem.links[0].href;
    return this.fileDetailsDocument(url).pipe(
      switchMap((fileDetails: FileDetailsDTO) => this.downloadEmbedded(fileDetails)),
      catchError(error => this.handleError(error))
    );
  }

  public getTmpFileContentB64(fileItem: FileDetailsDTO): Observable<string> {
    return this.getFileDetailsContentB64('tmpfiles/', fileItem);
  }

  public getFileContentB64(fileItem: FileDetailsDTO): Observable<string> {
    return this.getFileDetailsContentB64('documentFiles/', fileItem);
  }

  private getFileDetailsContentB64(
    serviceUrl: string,
    fileItem: FileDetailsDTO
  ): Observable<string> {
    let url =
      this._configuration.ServerWithUserApiUrl +
      serviceUrl +
      fileItem.identifier +
      '?format=base64';
    let headers = new HttpHeaders({
      Accept: '*/*'
    })
    return this.getAsText(url, headers);
  }

  public getAsText(url: string, headers?: HttpHeaders): Observable<string> {
    return this._http
      .get(url, {
        headers,
        responseType: 'text'
      }).pipe(catchError(error => this.handleError(error)));
  }

  public getDownloadableContentB64(
    downloadable: DownloadableDTO
  ): Observable<string> {
    return this.getDownloadable(downloadable, true);
  }
  public getDownloadableContent(
    downloadable: DownloadableDTO
  ): Observable<string> {
    return this.getDownloadable(downloadable, false);
  }

  private getDownloadable(
    downloadable: DownloadableDTO,
    base64: boolean
  ): Observable<string> {
    let url = downloadable.links[0].href;
    if (base64) {
      url = url + '?format=base64';
    }

    return this._http
      .get(url, {
        headers: new HttpHeaders({
          Accept: '*/*'
        }),
        responseType: 'text'
      })
      .pipe(catchError(error => this.handleError(error)));
  }

  public fileDetailsDocumentWithSignatures(
    url: string
  ): Observable<FileDetailsDTO> {
    let urlWithExpasion = url + '?expand=signatures,signatures.verification';
    return this._http
      .get<FileDetailsDTO>(urlWithExpasion)
      .pipe(catchError(error => this.handleError(error)));
  }

  public fileDetailsDocument(url: string): Observable<FileDetailsDTO> {
    return this._http
      .get<FileDetailsDTO>(url)
      .pipe(catchError(error => this.handleError(error)));
  }

  public generateTemplateByTask(
    task: TaskDTO,
    template: TemplateDTO
  ): Observable<FileDetailsDTO> {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'tasks/' +
      task.identifier +
      '/document/generate';
    if (template != null) {
      url = url + '?templateId=' + template.identifier;
    }

    return this._http
      .get<FileDetailsDTO>(url)
      .pipe(catchError(error => this.handleError(error)));
  }

  public findTemplatesByTask(
    task: TaskDTO
  ): Observable<PaginationDTO<TemplateDTO>> {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'tasks/' +
      task.identifier +
      '/document/templates';

    return this._http
      .get<PaginationDTO<TemplateDTO>>(url)
      .pipe(catchError(error => this.handleError(error)));
  }

  public generateTemplateByDocumentClass(
    template: TemplateDTO,
    parameters: string
  ): Observable<FileDetailsDTO> {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'templates/' +
      template.identifier +
      '/generate';
    if (parameters != null) {
      url += '?' + parameters;
    }

    return this._http
      .get<FileDetailsDTO>(url)
      .pipe(catchError(error => this.handleError(error)));
  }

  public findTemplatesByDocumentClass(
    documentClass: string,
    organizationalUnit: string
  ): Observable<PaginationDTO<TemplateDTO>> {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'templates?documentClassId=' +
      documentClass +
      '&organizationalUnitId=' +
      organizationalUnit;

    return this._http
      .get<PaginationDTO<TemplateDTO>>(url)
      .pipe(catchError(error => this.handleError(error)));
  }

  public findTemplatesByDocumentClassName(
    documentClassName: string,
    projectEntityId: string,
    division: string
  ): Observable<PaginationDTO<TemplateDTO>> {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'templates?documentClassName=' +
      documentClassName +
      '&projectEntityId=' +
      projectEntityId +
      '&division=' +
      division;


    return this._http
      .get<PaginationDTO<TemplateDTO>>(url)
      .pipe(catchError(error => this.handleError(error)));
  }

  public findTemplateByName(
    name: string
  ): Observable<PaginationDTO<TemplateDTO>> {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'templates?name=' +
      name;


    return this._http
      .get<PaginationDTO<TemplateDTO>>(url)
      .pipe(catchError(error => this.handleError(error)));
  }


  public findTemplatesName(
    name: string
  ): Observable<PaginationDTO<TemplateDTO>> {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'templates?name=' +
      name;


    return this._http
      .get<PaginationDTO<TemplateDTO>>(url)
      .pipe(catchError(error => this.handleError(error)));
  }


  public findTemplatesByDocument(
    documentClass: string,
    projectEntityId: string,
    division: string
  ): Observable<PaginationDTO<TemplateDTO>> {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'templates?documentClassId=' +
      documentClass +
      '&projectEntityId=' +
      projectEntityId +
      '&division=' +
      division;


    return this._http
      .get<PaginationDTO<TemplateDTO>>(url)
      .pipe(catchError(error => this.handleError(error)));
  }

  // http://localhost:8080/plyca/userAPI/v1/dossiers/20120029000001/procedures
  public getProcedures(
    dossierId: string,
    expansion?: string
  ): Observable<PaginationDTO<ProcedureDTO>> {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'dossiers/' +
      dossierId +
      '/procedures';
    if (expansion) {
      url += '?expand=' + expansion;
    }
    return this._http
      .get<PaginationDTO<ProcedureDTO>>(url)
      .pipe(catchError(error => this.handleError(error)));
  }

  // http://localhost:8080/plyca/userAPI/v1/users/esnejame/auditTasks
  // http://localhost:8080/plyca/userAPI/v1/dossiers/20140029000002/auditTasks

  public getAuditTasksProcedure = (
    dossierId: string,
    procedureId: string,
    running?: boolean,
    showInternalProcesses?: boolean
  ): Observable<PaginationDTO<AuditTaskDTO>> => {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'dossiers/' +
      dossierId +
      '/procedures/' +
      procedureId +
      '/auditTasks?expand=expansionSet:WEBCLIENT_PROJECT';

    if (running) {
      url += '&type=RUNNING';
    }

    if (showInternalProcesses) {
      url += '&addInternalTasks=true';
    }
    return this._http
      .get<PaginationDTO<AuditTaskDTO>>(url)
      .pipe(catchError(error => this.handleError(error)));
  };

  public getAuditTasksExp = (
    dossierId: string,
    running?: boolean
  ): Observable<PaginationDTO<AuditTaskDTO>> => {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'dossiers/' +
      dossierId +
      '/auditTasks?expand=expansionSet:WEBCLIENT_PROJECT';

    if (running) {
      url += '&type=RUNNING';
    }
    return this._http
      .get<PaginationDTO<AuditTaskDTO>>(url)
      .pipe(catchError(error => this.handleError(error)));
  };

  public getAuditPendingTasksExp = (
    dossierId: string
  ): Observable<PaginationDTO<AuditTaskDTO>> => {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'dossiers/' +
      dossierId +
      '/auditTasks';
    url += '?dateDesp=null';

    return this._http
      .get<PaginationDTO<AuditTaskDTO>>(url)
      .pipe(catchError(error => this.handleError(error)));
  };
  public getProceduresCode = (): Observable<PaginationDTO<MasterDataDTO>> => {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'masterData/PROCEDIMIENTOSCONTRA/data/data';

    return this._http
      .get<PaginationDTO<MasterDataDTO>>(url)
      .pipe(catchError(error => this.handleError(error)));
  };
  /*
  * GENERIC HANDLER FOR ERRORS
  */
  private handleError(error: HttpErrorResponse): Observable<any> {
    return throwError(error);
  }

  public uploadSignature(
    signature: TmpFileDTO
  ): Observable<DownloadableDTO> {
    signature.class = 'com.nexusit.plyca.commonUtil.dto.TmpFileDTO';
    let serviceUrl: string =
      this._configuration.ServerWithUserApiUrl + 'tmpfiles';
    return this._http
      .post<DownloadableDTO>(serviceUrl, JSON.stringify(signature))
      .pipe(catchError(error => this.handleError(error)));
  }

  public getMasterData = (idTabla: string): Observable<MasterData[]> => {
    let url =
      this._configuration.ServerWithUserApiUrl + 'masterData/' + idTabla;
    return this._http
      .get<MasterData[]>(url)
      .pipe(catchError(error => this.handleError(error)));
  };


  private getMasterDataValuesURL(idTabla: string, filterId?: string, exactFilter?: boolean): string {
    if (filterId && exactFilter) {
      return this._configuration.URL_BASE + this._configuration.MASTERDATA_SERVICE_URL + idTabla + '/data?filterProperties=S&filters=identifier%3D\'' + filterId + '\'';
    } else if (filterId) {
      return this._configuration.URL_BASE + this._configuration.MASTERDATA_SERVICE_URL + idTabla + '/data?filterProperties=S&filters=identifier%3D' + filterId;
    } else {
      return this._configuration.URL_BASE + this._configuration.MASTERDATA_SERVICE_URL + idTabla + '/data';
    }
  }

  public getMasterDataValues = (
    idTabla: string
    , filterId?: string
    , exactFilter?: boolean
    , expandStr?: string
  ): Observable<PaginationDTO<any>> => {
    let url = this.getMasterDataValuesURL(idTabla, filterId, exactFilter);


    let parameters = {};

    if (expandStr != undefined) {
      parameters = {
        params: {
          expand: expandStr
        }
      };
    }


    return this._http
      .get<PaginationDTO<any>>(url, parameters)
      .pipe(catchError(error => this.handleError(error)));
  };

  public getDossierFolders(idDossier: string): Observable<PaginationDTO<any>> {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'dossiers/' +
      idDossier +
      '/folders';
    return this._http
      .get<PaginationDTO<any>>(url)
      .pipe(catchError(error => this.handleError(error)));
  }

  public getDossierLastEvalTime(idDossier: string): Observable<Boolean> {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'dossiers/' +
      idDossier +
      '/rulesLastExec';
    let result = this._http
      .get<Boolean>(url);

    return result;
  }

  public getDocuments = (): Observable<PaginationDTO<any>> => {
    let url = this._configuration.ServerWithUserApiUrl + 'documents';
    return this._http
      .get<PaginationDTO<any>>(url)
      .pipe(catchError(error => this.handleError(error)));
  };

  public getDocumentsExp = (
    exp: String,
    folderId?: String
  ): Observable<PaginationDTO<DocumentDTO>> => {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'projects/' +
      exp +
      '/documents?page=0&size=999';
    if (folderId) {
      url = url + '&documentFolder=' + folderId;
    }
    return this._http
      .get<PaginationDTO<DocumentDTO>>(url)
      .pipe(catchError(error => this.handleError(error)));
  };

  public getDocument = (
    id: String,
    expansion?: string
  ): Observable<DocumentDTO> => {
    let url = this._configuration.ServerWithUserApiUrl + 'documents/' + id;
    if (expansion) {
      url += '?' + expansion;
    }
    return this._http
      .get<DocumentDTO>(url)
      .pipe(catchError(error => this.handleError(error)));
  };

  public printDocument = (currentFile: FileDetailsDTO): Observable<any> => {
    if (currentFile && (currentFile instanceof BlobFileDetails)) {
      return of((<BlobFileDetails>currentFile).fileContent)
        .pipe(
          tap((blob: Blob) => {
            const blobUrl = URL.createObjectURL(blob);
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.src = blobUrl;
            document.body.appendChild(iframe);
            return iframe.contentWindow.print();
          }),
          catchError(error => this.handleError(error))
        );
    }
    let url = currentFile.download.links[0].href + '?embedded=true';
    return this._http
      .get(url, {
        headers: new HttpHeaders({
          Accept: '*/*'
        }),
        responseType: 'blob'
      })
      .pipe(
        tap((blob: Blob) => {
          const blobUrl = URL.createObjectURL(blob);
          const iframe = document.createElement('iframe');
          iframe.style.display = 'none';
          iframe.src = blobUrl;
          document.body.appendChild(iframe);
          return iframe.contentWindow.print();
        }),
        catchError(error => this.handleError(error))
      );
  };

  public getDocumentContentAsText = (currentFile: FileDetailsDTO): Observable<any> => {
    let url = currentFile.download.links[0].href + '?embedded=true';
    return this._http
      .get(url, {
        headers: new HttpHeaders({
          Accept: '*/*'
        }),
        responseType: 'text'
      })
      .pipe(
        tap((text: string) => {
          return text;
        }),
        catchError(error => this.handleError(error))
      );
  };

  public getSignatureDetail(signature: SignatureDTO): Observable<SignatureDTO> {
    console.log('signature: ', signature);
    let links: Link[];
    links = signature.links;

    if (links != null && links[0].href) {
      return this._http
        .get<SignatureDTO>(links[0].href)
        .pipe(catchError(error => this.handleError(error)));
    } else {
      return null;
    }
  }

  public getVersionHistory = (
    id: String
  ): Observable<PaginationDTO<DocumentVersionDTO>> => {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'documents/' +
      id +
      '/versions';
    return this._http
      .get<PaginationDTO<DocumentVersionDTO>>(url)
      .pipe(catchError(error => this.handleError(error)));
  };

  public getAttributes = (): Observable<AttributeDTO> => {
    return this._http
      .get<AttributeDTO>(this.getAttributesUrl())
      .pipe(catchError(error => this.handleError(error)));
  };

  public getAttribute = (id: string, params?: string): Observable<any> => {
    let url = this.getAttributesUrl() + id;

    if (params) {
      url += '?' + params;
    }

    return this._http
      .get<any>(url)
      .pipe(catchError(error => this.handleError(error)));
  };
  public getAttributeValue = (id: string, params?: string): Observable<any> => {
    let url = this.getAttributesUrl() + id + '/values';
    if (params) {
      url += '?' + params;
    }
    return this._http
      .get<any>(url)
      .pipe(catchError(error => this.handleError(error)));
  };

  public putAttributeValue = (attribute): Observable<any> => {
    let url = this.getAttributesUrl() + attribute.identifier;
    return this._http
      .put(url, JSON.stringify(attribute))
      .pipe(catchError(error => this.handleError(error)));
  };


  // Servicios de busqueda
  public getSearchSetting(id: string): Observable<any> {
    let searchUrl = this._configuration.ServerWithUserApiUrl + 'searchsettings/';
    console.log('*** SEARCH GENERIC********URL DEL SERVICIO PANTALLA BUSCADOR: ' + searchUrl + id);
    return this._http
      .get<any>(searchUrl + id)
      .pipe(catchError(error => this.handleError(error)));
  };

  public getResultSearchSetting(
    urlService: string,
    paramsMap?: Map<string, string>
  ): Observable<any> {
    let url = urlService;
    if (paramsMap !== undefined && paramsMap.size > 0) {

      let cadenaFilter = '';
      let separador: string;

      if (urlService.endsWith('?')) {
        separador = '';
      } else if (urlService.indexOf('?') > 0) {
        separador = '&';
      } else {
        separador = '?'
      }
      // Convertimos el map es un query string
      for (let [key, value] of paramsMap) {
        cadenaFilter += separador + key + '=' + encodeURIComponent(value);
        separador = '&';
      }
      url = url + cadenaFilter;
    }

    console.log('*** SEARCH GENERIC********URL DEL SERVICIO DE CONSULTA PARAMETRIZADA: ' + url);
    return this._http
      .get<any>(url)
      .pipe(catchError(error => this.handleError(error)));
  };

  public getDataMasterTable = (
    urlService: string,
    params: string
  ): Observable<any> => {
    let url = urlService + '/data';

    if (params !== undefined && params !== '') {
      url = url + params;
    }

    console.log('*** SEARCH GENERIC********URL DEL SERVICIO DE CONSULTA PARAMETRIZADA: ' + url);
    return this._http
      .get<any>(url)
      .pipe(catchError(error => this.handleError(error)));
  };

  public getUser = (user: UserDTO): Observable<UserDTO> => {

    if (user?.links && user.links[0].href) {
      return this._http
        .get<UserDTO>(user.links[0].href)
        .pipe(catchError(error => this.handleError(error)));
    } else {
      return this.get<UserDTO>(
        this._configuration.USER_SERVICE_URL,
        user.identifier
      );

    }
  };


  public getOrganizationalUnits = (parameters?:
    | HttpParams
    | {
      [param: string]: string | string[];
    }): Observable<any> => {

    let url = this._configuration.ServerWithUserApiUrl + 'organizationalUnits';
    let options = {
      params: parameters
    };
    return this._http
      .get<PaginationDTO<OrganizationalUnitDTO>>(url, options)
      .pipe(catchError(error => this.handleError(error)));
  };

  public getOrganizationalUnit = (
    organizationalUnit: OrganizationalUnitDTO
  ): Observable<OrganizationalUnitDTO> => {
    let links: Link[];
    links = organizationalUnit.links;
    console.log('link: ', links[0].href);
    if (links != null && links[0].href) {
      return this._http
        .get<OrganizationalUnitDTO>(links[0].href)
        .pipe(catchError(error => this.handleError(error)));
    } else {
      return null;
    }
  };

  public getMillestones = (
    dossier: string,
    fromDate: any,
    toDate: any
  ): Observable<PaginationDTO<MilestoneDTO>> => {
    let url = this._configuration.ServerWithUserApiUrl;
    if (dossier) {
      url = url + 'dossiers/' + dossier + '/';
    }

    if (toDate && fromDate) {
      url = url + 'milestones?fromDate=' + fromDate;
      url = url + '&toDate=' + toDate;
    }

    // console.log('Hitos del usuario, URL: ' + url);
    return this._http
      .get<PaginationDTO<MilestoneDTO>>(url)
      .pipe(catchError(error => this.handleError(error)));
  };

  public getDossierTenders = (dossier: string): Observable<PaginationDTO<TenderDTO>> => {
    let url = this._configuration.ServerWithUserApiUrl;
    if (dossier) {
      url = url + 'dossiers/' + dossier + '/tenders';
      return this._http
        .get<PaginationDTO<TenderDTO>>(url)
        .pipe(catchError(error => this.handleError(error)));
    } else {
      return null;
    }
  };

  public getDossierAward = (awardId: string): Observable<AwardDTO> => {
    let url = this._configuration.ServerWithUserApiUrl;
    url = url + 'awards/' + awardId;
    return this._http
      .get<AwardDTO>(url)
      .pipe(catchError(error => this.handleError(error)));
  };
  public getDossierAwards = (dossier: string): Observable<any> => {
    let url = this._configuration.ServerWithUserApiUrl;
    if (dossier) {
      //      url = url + 'dossiers/' + dossier + '/awards/';
      url += '/awards?dossierId=' + dossier;
      return this._http
        .get<PaginationDTO<AwardDTO>>(url)
        .pipe(catchError(error => this.handleError(error)));
    } else {
      return null;
    }
  };

  public getPentahoReport = (): Observable<any> => {
    let url = this._configuration.ServerWithUserApiUrl;
    url += 'reports/pentaho';
    return this._http
      .get<PaginationDTO<ReportDTO>>(url)
      .pipe(catchError(error => this.handleError(error)));
  };

  public runReport = (reportName: string): Observable<any> => {
    let url = this._configuration.ServerWithUserApiUrl;
    url += 'reports/run?reportName=' + reportName;
    return this._http

      .get<PaginationDTO<any>>(url)
      .pipe(catchError(error => this.handleError(error)));
  };


  public getDossierTender = (tenderId: string): Observable<TenderDTO> => {
    let url = this._configuration.ServerWithUserApiUrl;
    url = url + 'tenders/' + tenderId;
    return this._http
      .get<TenderDTO>(url)
      .pipe(catchError(error => this.handleError(error)));
  };

  public getDossierTenderByDocId = (doc: DocumentDTO): Observable<PaginationDTO<TenderDTO>> => {
    // let url = this._configuration.TENDER_SERVICE_V2_URL;
    let url = this._configuration.URL_BASE + '/' + this._configuration.UserApiUrl + 'v2/tenders'
    let parameters = {
      params: {
        projectEntityIdentifier: getParentIdentifierFromString(doc.entity.division.identifier),
        divisionIdentifierId: 0,
        documentClassIdentifier: '00006',
        orderNumber: doc.entity.orderNumber,
        page: 0,
        size: 9999
      }
    };
    return this._http
      .get<PaginationDTO<TenderDTO>>(url, parameters)
      .pipe(catchError(error => this.handleError(error)));
  };

  public getTenderEvaluationCommittee = (
    projectId: string
  ): Observable<PaginationDTO<TenderEvaluationCommitteeDTO>> => {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'dossiers/' +
      projectId +
      '/tenderevaluationcommittees/';
    return this._http
      .get<PaginationDTO<TenderEvaluationCommitteeDTO>>(url)
      .pipe(catchError(error => this.handleError(error)));
  };

  // public deleteTenderEvaluationCommittee(
  //   evaluationCommitteeId: string
  // ): Observable<any> {
  //   let url =
  //     this._configuration.ServerWithUserApiUrl +
  //     'tenderevaluationcommittees/' +
  //     evaluationCommitteeId;
  //   return this._http
  //     .delete(url)
  //     .pipe(catchError(error => this.handleError(error)));
  // }

  public updateTenderEvaluationCommittee(
    evaluationCommittee: TenderEvaluationCommitteeDTO
  ): Observable<any> {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'tenderevaluationcommittees/' +
      evaluationCommittee.identifier;
    return this._http
      .put(url, JSON.stringify(evaluationCommittee))
      .pipe(catchError(error => this.handleError(error)));
  }

  public insertTenderEvaluationCommittee(
    evaluationCommittee: TenderEvaluationCommitteeDTO
  ): Observable<TenderEvaluationCommitteeDTO> {
    let url =
      this._configuration.ServerWithUserApiUrl + 'tenderevaluationcommittees';
    return this._http
      .post<TenderEvaluationCommitteeDTO>(
        url,
        JSON.stringify(evaluationCommittee)
      )
      .pipe(catchError(error => this.handleError(error)));
  }

  public getProcurementCommittee = (
    idProcurementCommitte: string
  ): Observable<ProcurementCommitteeDTO> => {
    let url =
      this._configuration.ServerWithUserApiUrl +
      '/procurementCommittees/' +
      idProcurementCommitte;
    let parameters = {
      params: {
        expand: 'expansionSet:detail,phase'
      }
    };
    return this._http
      .get<ProcurementCommitteeDTO>(url, parameters)
      .pipe(catchError(error => this.handleError(error)));
  };

  public getMemberProcurementCommittee = (
    idProcurementCommitte: string,
    memberId: string,
    expandFragments?: boolean
  ): Observable<MemberProcurementCommitteeDTO> => {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'membersProcurementCommittee/' +
      memberId;
    url += '?procurementCommitteeId=' + idProcurementCommitte;
    if (expandFragments) {
      url += '&expand=tendersFragments';
    }

    return this._http
      .get<MemberProcurementCommitteeDTO>(url)
      .pipe(catchError(error => this.handleError(error)));
  };

  public updateFragmentsByMember = (
    idProcurementCommitte: string,
    memberId: string,
    secretos: any
  ): Observable<any> => {
    let serviceUrl =
      this._configuration.ServerWithUserApiUrl +
      'procurementCommittees/' +
      idProcurementCommitte +
      '/membersProcurementCommittee/' +
      memberId;
    return this._http
      .put(serviceUrl, JSON.stringify(secretos))
      .pipe(catchError(error => this.handleError(error)));
  };

  public decipherTenders(idProcurementCommitte: string): Observable<ActionDefinitionDTO> {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'procurementCommittees/' +
      idProcurementCommitte +
      '/actions?id=DECIPHER_TENDER';
    return this._http.get<PaginationDTO<ActionDefinitionDTO>>(url).pipe(
      switchMap((dto: PaginationDTO<ActionDefinitionDTO>) => {
        if (dto && dto.content && dto.content[0] && dto.content[0].enabled) {
          console.log('Accion recuperada ', dto.content[0]);
          let actionUrl =
            this._configuration.ServerWithUserApiUrl +
            '/procurementCommittees/' +
            idProcurementCommitte +
            '/actions/' +
            dto.content[0].identifier;
          console.log('URL DE LA ACCION' + actionUrl);
          return this._http.get<any>(actionUrl);
        } else {
          return throwError(this.translationService.instant('Actions.disabled'));
        }
      }),
      catchError(error => this.handleError(error))
    );
  };

  public updateRequestDocument = (
    idProcurementCommitte: string,
    idUpdatedFile: string
  ): Observable<any> => {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'procurementCommittees/' +
      idProcurementCommitte +
      '/actions?id=UPDATE_REQUEST_DOCUMENT';

    return this._http.get<PaginationDTO<ActionDefinitionDTO>>(url).pipe(
      flatMap((dto: PaginationDTO<ActionDefinitionDTO>) => {
        console.log('Accion recuperada ', dto.content[0]);
        let actionUrl =
          this._configuration.ServerWithUserApiUrl +
          'procurementCommittees/' +
          idProcurementCommitte +
          '/actions/' +
          dto.content[0].identifier +
          '?UPDATED_FILE_ID=' +
          idUpdatedFile;
        console.log('URL DE LA ACCION' + actionUrl);
        return this._http.get<any>(actionUrl);
      }),
      catchError(error => this.handleError(error))
    );
  };

  public generateRequestDocument = (
    committee: ProcurementCommitteeDTO
  ): Observable<any> => {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'procurementCommittees/' +
      committee.identifier +
      '/actions?id=GENERATE_REQUEST_DOCUMENT';

    return this._http.get<PaginationDTO<ActionDefinitionDTO>>(url).pipe(
      flatMap((dto: PaginationDTO<ActionDefinitionDTO>) => {
        console.log('Accion recuperada ', dto.content[0]);
        let actionUrl =
          this._configuration.ServerWithUserApiUrl +
          'procurementCommittees/' +
          committee.identifier +
          '/actions/' +
          dto.content[0].identifier;
        console.log('URL DE LA ACCION' + actionUrl);
        return this._http.get<any>(actionUrl);
      }),
      catchError(error => this.handleError(error))
    );
  };

  public updateSeeTenderDocument = (
    tenderDocumentEnvelopeId: string
  ): Observable<any> => {
    let document = new EnvelopeDocumentDTO();
    document.identifier = tenderDocumentEnvelopeId;
    document.see = true;
    return this.patch(this._configuration.ENVELOPEDOCUMENT_SERVICE_URL, document);
  };

  public updateProjectLotDesert = (
    lote: ProcurementProjectLotDTO,
    dossierId: string
  ): Observable<any> => {
    let url =
      this._configuration.PROCUREMENTPROJ_SERVICE_URL +
      dossierId +
      '/contexts/desert/procurementProjectsLots';
    return this.patch(url, lote);
  };

  public getAvailableActions(
    targetType: string,
    targetId: string,
    taskId?: string,
    taskExpansion?: string[]
  ): Observable<LinkedActionsDTO> {
    // Este parámetro solo para pintar las acciones del panel de control
    // &visibleUI=true
    let url = this._configuration.ServerWithUserApiUrl;
    url += 'actions/available?expand=expansionSet:parametersDefinition&actionObjType=' + targetType + '&targetId=' + targetId;
    if (taskId) {
      url += '&taskId=' + taskId;
      if (taskExpansion) {
        url += '&taskExpansion=' + taskExpansion;
      }
    }
    return this._http
      .get<LinkedActionsDTO>(url)
      .pipe(catchError(error => this.handleError(error)));

  }

  getActionsByObjectType(objectType: string, parameters?: string): Observable<PaginationDTO<ActionDefinitionDTO>> {
    let url = this._configuration.ServerWithUserApiUrl;
    url += 'actions?actionObjType=' + objectType; // + '&enabled=true&visible=true';
    if (parameters) {
      url += '&' + parameters;
    }
    return this._http
      .get<PaginationDTO<ActionDefinitionDTO>>(url)
      .pipe(catchError(error => this.handleError(error)));
  }

  public getObjectActions(
    objectType: string,
    objectId: string,
    actionClasification: string,
    excludeClasification: string,
  ): Observable<any> {
    let url = this._configuration.ServerWithUserApiUrl;
    if (objectType) {
      switch (objectType) {
        case 'USER': {
          url += 'users/' + objectId;
          break;
        }
        case 'PROCUREMENTDOSSIER': {
          url += 'dossiers/' + objectId;
        }
      }
    }
    url += '/actions?enabled=true&visible=true';
    if (actionClasification) {
      url += '&actionClasification=' + actionClasification;
    }
    if (excludeClasification) {
      url += '&excludeClasification=' + excludeClasification;
    }
    console.log('Cargando acciones URL: ', url);
    return this._http
      .get<PaginationDTO<ActionDefinitionDTO>>(url)
      .pipe(catchError(error => this.handleError(error)));
  }

  public getUserActions(
    userId: string,
    actionClasification?: string
  ): Observable<any> {
    return this.getObjectActions('USER', userId, actionClasification, null);
  }

  public runActionLink(
    action: ActionDTO,
    parameters?: string
  ): Observable<ActionResultDTO> {
    let url = action.links[0].href;
    return this.runActionUsingGET(url, parameters);
  }

  public runActionByName(
    actionName: string,
    parameters?: string
  ): Observable<ActionResultDTO> {
    let url = this._configuration.ServerWithUserApiUrl;
    url += 'actions/executeByName/' + actionName;
    // if (parameters) {
    //   url += '?' + parameters;
    // }
    // console.log('Ejecutando accion URL: ', url);
    // return this._http.get<ActionResultDTO>(url);
    return this.runActionUsingGET(url, parameters);
  }

  public runAction(
    // objectType: string,
    actionId: string,
    objectId?: string,
    parameters?: string
  ): Observable<ActionResultDTO> {
    console.log('Ejecutando accion URL: ', actionId, objectId, parameters);
    let url = this._configuration.ServerWithUserApiUrl;
    // if (objectType) {
    //   switch (objectType) {
    //     case 'USER': {
    //       url += 'users/' + objectId;
    //       break;
    //     }
    //     case 'PROCUREMENTDOSSIER': {
    //       url += 'dossiers/' + this.normalizaDossierId(objectId);
    //       break;
    //     }
    //     case 'PROCUREMENTPROJECT': {
    //       url += 'projects/' + this.normalizaDossierId(objectId);
    //       break;
    //     }
    //     case 'DOCUMENTS': {
    //       // url += this._configuration.DOCUMENTS_SERVICE_URL + objectId;
    //       url += 'documents/' + objectId;
    //       break;
    //     }
    //     case 'TASK': {
    //       url += 'tasks/' + objectId;
    //       break;
    //     }
    //   }
    //   url += '/';
    // }
    url += 'actions/' + actionId + '/execute';
    // Si no tenemos objectType atacamos al propio servicio de ejecucion de acciones
    // if (!objectType) {
    //   let paramTarget = '';


    // si llega objectId lo concatenamos al parámetro target.
    // SOLO NO PUEDE LLEGAR SI DIRECTAMENTE SE ESTABLECEN LOS TARGET EN LOS PARÁMETROS EN ORIGEN
    if (objectId) {
      let paramTarget = 'TARGET=' + objectId;
      parameters = parameters ? parameters + '&' + paramTarget : paramTarget;
    }


    // }
    // if (parameters) {
    //   url += '?' + parameters;
    // }
    // console.log('Ejecutando accion URL: ', url);
    // return this._http.get<ActionResultDTO>(url);
    return this.runActionUsingGET(url, parameters);
  }

  downloadLogResult(identifier: string) {
    let url =
      this._configuration.ServerWithUserApiUrl + 'action/requests/' + identifier + '/log/';
    return this._http
      .get(url, {
        headers: new HttpHeaders({
          Accept: '*/*'
        }),
        responseType: 'blob'
      })
      .pipe(
        tap((blob: Blob) => saveAs(blob, identifier + '.txt')),
        catchError(error => this.handleError(error))
      );
  }

  // public runActionV2(
  //   actionId: string,
  //   parameters?: string
  // ): Observable<ActionResultDTO> {
  //   // ): Observable<ActionExecutionDTO> {
  //   return this.runAction('', '', actionId, parameters);
  //   // let url = this._configuration.ServerWithUserApiUrl;
  //   // url += 'actions/' + action.identifier + '/execute';
  //   // if (parameters) {
  //   //   url += '?' + parameters;
  //   // }
  //   // console.log('Ejecutando accion URL: ', url);
  //   // return <Observable<ActionExecutionDTO>>this._http.get(url);
  // }

  public runActionUsingGET(url: string, parameters?: string): Observable<ActionResultDTO> {
    if (parameters) {
      url += '?' + parameters;
    }
    console.log('Ejecutando accion URL: ', url);
    return this._http.get<ActionResultDTO>(url);
  }

  public runActionUsingPUT(
    action: ActionDTO,
    parameters?: string
  ): Observable<any> {
    let url = this._configuration.ServerWithUserApiUrl;
    url += 'actions/execute';
    if (parameters) {
      url += '?' + parameters;
    }
    console.log('Ejecutando accion URL: ', url);
    return this._http.put(url, JSON.stringify(action));
  }

  public getAvailableAction(id: string, targetId: string, targetType: string): Observable<any> {
    // Este parámetro solo para pintar las acciones del panel de control
    // &visibleUI=true
    let url = this._configuration.ServerWithUserApiUrl +
      'actions/available?expand=expansionSet:parametersDefinition&id=' + id + '&actionObjType=' + targetType + '&targetId=' + targetId;
    return this._http
      .get<LinkedActionsDTO>(url)
      .pipe(catchError(error => this.handleError(error)));

  }

  public getAction(id: string): Observable<PaginationDTO<ActionDefinitionDTO>> {
    let url = this._configuration.ServerWithUserApiUrl + 'actions?id=' + id;
    return this._http
      .get<PaginationDTO<ActionDTO>>(url)
      .pipe(catchError(error => this.handleError(error)));
  }

  public validateUserAction(
    action: ActionDefinitionDTO
  ): Observable<HttpResponse<any>> {
    let validateActionInsert =
      this._configuration.ServerWithUserApiUrl + 'actions/validations/Insert';
    return this._http
      .put(validateActionInsert, JSON.stringify(action), {
        observe: 'response'
      })
      .pipe(catchError(error => this.handleError(error)));
  }

  public validateDTO(scheme: string, dto: any): Observable<HttpResponse<any>> {
    let validateActionInsert =
      this._configuration.ServerWithUserApiUrl + scheme;
    return this._http
      .put(validateActionInsert, JSON.stringify(dto, (k, v) => k === '_parent' ? undefined : v), {
        observe: 'response'
      })
      .pipe(catchError(error => this.handleError(error)));
  }

  public createUserAction(
    action: ActionDefinitionDTO
  ): Observable<HttpResponse<any>> {
    let url = this._configuration.ServerWithUserApiUrl + 'actions/';
    return this._http
      .post(url, JSON.stringify(action), { observe: 'response' })
      .pipe(catchError(error => this.handleError(error)));
  }

  public updateUserAction(
    action: ActionDefinitionDTO
  ): Observable<HttpResponse<any>> {
    let url =
      this._configuration.ServerWithUserApiUrl + 'actions/' + action.identifier;
    return this._http
      .put(url, JSON.stringify(action), { observe: 'response' })
      .pipe(catchError(error => this.handleError(error)));
  }

  public getInterfaceSettings = (
    interfaceSettings: string,
    preserveAdaptConfig = false
  ): Observable<InterfaceSettings> => {
    let productObservable = this._http.get<InterfaceSettings>(
      'assets/json/' + interfaceSettings
    );
    let adaptObservable = this._http
      .get<InterfaceSettings>('assets/json/adapt/' + interfaceSettings)
      .pipe(
        catchError((error: any) => {
          if (error.status === 404) {
            return of(new InterfaceSettings());
          } else {
            throwError(error);
          }
        })
      );
    return forkJoin<InterfaceSettings, InterfaceSettings>([
      productObservable,
      adaptObservable
    ]).pipe(
      map(([productSettings, adaptSettings]) =>
        this.formService.mergeInterfaceSettings(
          productSettings,
          adaptSettings || new InterfaceSettings(),
          preserveAdaptConfig
        )
      ),
      catchError(error => this.handleError(error))
    );
  };

  public getProcurementProjectSteps = (stepsId: string): Observable<any> => {

    let url = this._configuration.ServerWithUserApiUrl + 'projectDefinitions/procurementProjectDefinition';

    return this._http
      .get<ProcurementProjectDefinitionsDTO[]>(url)
      .pipe(catchError(error => this.handleError(error)));

    /*
      return this._http
        .get<InterfaceSettings>('assets/json/' + stepsId)
        .pipe(
          take(1),
          catchError(error => this.handleError(error))
        );
    */
  };

  public getProcurementProjectValidations = (
    dossier: ProcurementProjectDTO,
    testMapping: boolean
  ): Observable<any> => {
    let url =
      this._configuration.ServerWithUserApiUrl + 'projects/validations/';
    if (testMapping) {
      url = url + 'TestMapping';
    } else if (dossier.identifier) {
      url = url + 'Update';
    } else {
      url = url + 'Insert';
    }
    return this._http
      .put(url, JSON.stringify(dossier))
      .pipe(catchError(error => this.handleError(error)));
  };

  public createProcurementProject = (
    dossier: ProcurementProjectDTO,
    context?: string
  ): Observable<ProcurementProjectDTO> => {
    let url = this._configuration.ServerWithUserApiUrl + 'procurementProjects';
    if (context) {
      if (dossier.context == null) {
        dossier.context = new ObjectContextDTO();
      }

      dossier.context.name = context;
    }
    return this._http.post<ProcurementProjectDTO>(url, JSON.stringify(dossier));
  };

  public updateProcurementProject = (
    dossier: ProcurementProjectDTO,
    context?: string
  ): Observable<any> => {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'procurementProjects/' +
      dossier.identifier;
    if (context) {
      if (dossier.context == null) {
        dossier.context = new ObjectContextDTO();
      }

      dossier.context.name = context;
    }
    return this._http.put(url, JSON.stringify(dossier));
  };


  // PENDIENTE DE HACER
  public updateProcurementProjectLot = (
    lot: ProcurementProjectLotDTO,
    context?: string
  ): Observable<any> => {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'procurementProjectsLots/' +
      lot.identifier;
    if (context) {
      if (lot.context == null) {
        lot.context = new ObjectContextDTO();
      }

      lot.context.name = context;

    }
    return this._http.put(url, JSON.stringify(lot));
  };


  public republicateCompanyProject = (
    dossier: CompanyProjectDTO
  ): Observable<any> => {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'companyProjects/' +
      dossier.identifier +
      '/republicate';
    return this._http
      .put(url, JSON.stringify(dossier))
      .pipe(catchError(error => this.handleError(error)));
  };

  public startProcurementProject = (
    dossier: ProcurementProjectDTO
  ): Observable<any> => {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'procurementProjects/' +
      dossier.identifier +
      '/start';
    return this._http
      .put(url, JSON.stringify(dossier))
      .pipe(catchError(error => this.handleError(error)));
  };




  public startContractModification = (
    contractModification: ContractModificationDTO
  ): Observable<any> => {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'contractModifications/' +
      contractModification.identifier +
      '/start';
    return this._http
      .put(url, JSON.stringify(contractModification))
      .pipe(catchError(error => this.handleError(error)));
  };






  public startRegisterContractModification = (
    registerContractModification: RegisterContractModificationDTO
  ): Observable<any> => {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'registerContractModifications/' +
      registerContractModification.identifier +
      '/start';
    return this._http
      .put(url, JSON.stringify(registerContractModification))
      .pipe(catchError(error => this.handleError(error)));
  };

  public startProject = (
    dossier: BaseProjectEntityDTO,
    url: any
  ): Observable<any> => {
    url = this._configuration.URL_BASE + url +
      dossier.identifier +
      '/start';
    return this._http
      .put(url, JSON.stringify(dossier))
      .pipe(catchError(error => this.handleError(error)));
  };



  public getProcurementProjectContract = (
    dossierId: string,
    expansion?: string
  ): Observable<any> => {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'procurementProjects/' +
      dossierId;
    if (expansion != undefined) {
      url =
        this._configuration.ServerWithUserApiUrl +
        'procurementProjects/' +
        dossierId +
        expansion;
    }
    // url += '?expand=BASIC_LOT';

    return this._http.get<ProcurementProjectDTO>(url).pipe(
      map((resp: ProcurementProjectDTO) => {
        return ProcurementProjectDTO.patchDTO(resp);
        //        return resp;
      }),
      catchError(error => this.handleError(error))
    );
  };




  public getProcurementProject = (
    dossierId: string,
    expansion?: string
  ): Observable<ProcurementProjectDTO> => {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'procurementProjects/' +
      dossierId;
    if (expansion != undefined) {
      url =
        this._configuration.ServerWithUserApiUrl +
        'procurementProjects/' +
        dossierId +
        expansion;
    }
    // url += '?expand=BASIC_LOT';

    return this._http.get<ProcurementProjectDTO>(url).pipe(
      map((resp: ProcurementProjectDTO) => {
        // if (!(resp.creationDate instanceof Date)) {
        //   resp.creationDate = new Date(resp.creationDate);
        // }
        // if (!(resp.startDate instanceof Date)) {
        //   resp.startDate = new Date(resp.startDate);
        // }
        // if (
        //   resp.execution &&
        //   resp.execution.planning &&
        //   resp.execution.planning.expectedStartDate &&
        //   !(resp.execution.planning.expectedStartDate instanceof Date)
        // ) {
        //   resp.execution.planning.expectedStartDate = new Date(
        //     resp.execution.planning.expectedStartDate
        //   );
        // }
        // if (
        //   resp.execution &&
        //   resp.execution.planning &&
        //   resp.execution.planning.limitDate &&
        //   !(resp.execution.planning.limitDate instanceof Date)
        // ) {
        //   resp.execution.planning.limitDate = new Date(
        //     resp.execution.planning.limitDate
        //   );
        // }
        return ProcurementProjectDTO.patchDTO(resp);
        //        return resp;
      }),
      catchError(error => this.handleError(error))
    );
  };

  public getProcurementProjectAM = (
    dossierId: string,
    expansion?: string
  ): Observable<any> => {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'procurementProjects/procurementProjectAM/' +
      dossierId;
    if (expansion != undefined) {
      url =
        this._configuration.ServerWithUserApiUrl +
        'procurementProjects/procurementProjectAM/' +
        dossierId +
        expansion;
    }

    return this._http.get<ProcurementProjectDTO>(url).pipe(
      map((resp: ProcurementProjectDTO) => {
        return ProcurementProjectDTO.patchDTO(resp);
      }),
      catchError(error => this.handleError(error))
    );
  };


  public getProcurementProjectWithLot = (
    dossierId: string
  ): Observable<ProcurementProjectDTO> => {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'procurementProjects/' +
      dossierId;
    url += '?expand=expansionSet:BASIC_LOT';

    return this._http.get<ProcurementProjectDTO>(url).pipe(
      map((resp: ProcurementProjectDTO) => {
        return resp;
      }),
      catchError(error => this.handleError(error))
    );
  };

  public getProcurementProjectLot = (
    lotId: string,
    expansion?: string
  ): Observable<ProcurementProjectLotDTO> => {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'procurementProjectsLots/' +
      lotId;
    if (expansion != undefined) {
      url =
        this._configuration.ServerWithUserApiUrl +
        'procurementProjectsLots/' +
        lotId +
        expansion;
    }

    return this._http.get<ProcurementProjectLotDTO>(url).pipe(
      map((resp: ProcurementProjectLotDTO) => {

        return ProcurementProjectLotDTO.patchDTO(resp);

      }),
      catchError(error => this.handleError(error))
    );
  };


  public getProcurementProjectBasedContract = (
    frameworkAgreementParent?: string,
    contractDivisionFrameworkAgreement?: string,
    isBasedContract?: string,
    configuration?: string
  ): Observable<ProcurementProjectDTO> => {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'procurementProjects/new';
    if (isBasedContract && frameworkAgreementParent) {
      url += '?configurations=' + configuration
        + '&isBasedContract=' + isBasedContract
        + '&frameworkAgreementParent=' + frameworkAgreementParent
        + '&contractDivisionFrameworkAgreement=' + contractDivisionFrameworkAgreement
    }

    return this._http.get<ProcurementProjectDTO>(url).pipe(
      map((resp: ProcurementProjectDTO) => {
        return ProcurementProjectDTO.patchDTO(resp);
      }),
      catchError(error => this.handleError(error))
    );
  };

  public getProcurementProjectSpecificContract = (
    dynamicPurchasingSystemParent?: string,
    categorySelectedSDA?: string,
    cpvSelectedSDA?: string,
    isSpecificContract?: string,
    configuration?: string
  ): Observable<ProcurementProjectDTO> => {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'procurementProjects/new';
    if (isSpecificContract && dynamicPurchasingSystemParent && cpvSelectedSDA) {
      if (categorySelectedSDA) {
        url += '?configurations=' + configuration
          + '&isSpecificContract=' + isSpecificContract
          + '&dynamicPurchasingSystemParent=' + dynamicPurchasingSystemParent
          + '&categorySelectedSDA=' + categorySelectedSDA
          + '&cpvSelectedSDA=' + cpvSelectedSDA
      } else {
        url += '?configurations=' + configuration
          + '&isSpecificContract=' + isSpecificContract
          + '&dynamicPurchasingSystemParent=' + dynamicPurchasingSystemParent
          + '&cpvSelectedSDA=' + cpvSelectedSDA
      }
    }

    return this._http.get<ProcurementProjectDTO>(url).pipe(
      map((resp: ProcurementProjectDTO) => {
        return ProcurementProjectDTO.patchDTO(resp);
      }),
      catchError(error => this.handleError(error))
    );
  };

  /*public getProcurementProjectSpecificContract = (
    dynamicPurchasingSystemParent?: string,
    categorySelectedSDA?: string,
    cpvSelectedSDA?: string,
    isSpecificContract?: string,
    configuration?: string
  ): Observable<ProcurementProjectDTO> => {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'procurementProjects/new';
    if (isSpecificContract && dynamicPurchasingSystemParent && cpvSelectedSDA) {
      if (categorySelectedSDA) {
        url += '?configurations=' + configuration
        + '&isSpecificContract=' + isSpecificContract
        + '&dynamicPurchasingSystemParent=' + dynamicPurchasingSystemParent
        + '&categorySelectedSDA=' + categorySelectedSDA
        + '&cpvSelectedSDA=' + cpvSelectedSDA
      } else {
        url += '?configurations=' + configuration
        + '&isSpecificContract=' + isSpecificContract
        + '&dynamicPurchasingSystemParent=' + dynamicPurchasingSystemParent
        + '&cpvSelectedSDA=' + cpvSelectedSDA
      }
    }

    return this._http.get<ProcurementProjectDTO>(url).pipe(
      map((resp: ProcurementProjectDTO) => {
        return ProcurementProjectDTO.patchDTO(resp);
      }),
      catchError(error => this.handleError(error))
    );
  };

  )*/

  public getCPVs = (): Observable<any> => {
    return this._http
      .get('assets/json/cpvs.json')
      .pipe(catchError(error => this.handleError(error)));
  };

  public getCPVsTree = (): Observable<any> => {
    return this._http
      .get('assets/json/cpvsTree.json')
      .pipe(catchError(error => this.handleError(error)));
  };

  public getEnvelopeDocumentModels = (): Observable<any> => {
    // return this._http
    //   .get<PaginationDTO<EnvelopeDocumentModel>>(url)
    //   .pipe(catchError(error => this.handleError(error)));
    return null;
  };

  public getEnvelopeDocumentModel = (): Observable<any> => {
    //    ): Observable<EnvelopeDocumentModel> => {
    // let url =
    //   this._configuration.ServerWithUserApiUrl + 'envelopeModels/' + id;
    // return this._http
    //   .get<EnvelopeDocumentModel>(url)
    //   .pipe(catchError(error => this.handleError(error)));
    return null;
  };

  public getConfigurations = (configurationGroup?: string): Observable<any> => {
    let url = this._configuration.ServerWithUserApiUrl + 'configurations';
    if (configurationGroup) {
      url += '?configurationGroup=' + configurationGroup
    }
    return this._http
      .get<PaginationDTO<ConfigurationDTO>>(url)
      .pipe(catchError(error => this.handleError(error)));
  };

  public getConfiguration = (
    configurationId: string, orgUnitId?: string
  ): Observable<ConfigurationDTO> => {
    // Consulta de propiedades generales
    let url =
      this._configuration.ServerWithUserApiUrl +
      'configurations/' +
      configurationId;
    // Si tenemos unidad organica consultamos su configuracion especifica
    if (orgUnitId) {
      url += '/entityConfiguration/' + orgUnitId;
    }
    return this._http
      .get<ConfigurationDTO>(url)
      .pipe(catchError(error => this.handleError(error)));
  };

  public getAccountingDocuments = (dossierId: string): Observable<any> => {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'dossiers/' +
      dossierId +
      '/accountingdocuments?page=0&size=9999';
    return this._http
      .get<PaginationDTO<AccountingDocumentDTO>>(url)
      .pipe(catchError(error => this.handleError(error)));
  };

  // metodos de auditoria de sistema
  public getEventAudits(
    filters: string
  ): Observable<PaginationDTO<EventAuditDTO>> {
    // por defecto filtramos a 100
    if (!filters) {
      filters = '?size=100';
    }
    let url = this._configuration.ServerWithPlatformApiUrl + 'audit?' + filters;
    // 'audit/?size=' +
    // filters.size +
    // '&page=0&operationTimeFrom=' +
    // operationTimeFrom;

    // console.log( 'URL: ' + url );
    return this._http
      .get<PaginationDTO<EventAuditDTO>>(url)
      .pipe(catchError(error => this.handleError(error)));
  }

  public getEventViewer(
    filters: string
  ): Observable<PaginationDTO<AudMessageDTO>> {
    let url = this._configuration.ServerWithUserApiUrl + 'audMessage/?' + filters;

    return this._http
      .get<PaginationDTO<AudMessageDTO>>(url)
      .pipe(catchError(error => this.handleError(error)));
  }

  public getEventAuditsStatistics(
    filters: string
  ): Observable<PaginationDTO<EventAuditStatisticDTO>> {
    let url =
      this._configuration.ServerWithPlatformApiUrl +
      '/audit/statistics?' +
      filters;

    return this._http
      .get<PaginationDTO<EventAuditStatisticDTO>>(url)
      .pipe(catchError(error => this.handleError(error)));
  }

  public getLogs(): Observable<PaginationDTO<LogDTO>> {
    let url = this._configuration.ServerWithPlatformApiUrl + '/logs/';

    return this._http
      .get<PaginationDTO<LogDTO>>(url)
      .pipe(catchError(error => this.handleError(error)));
  }

  public getLogFile(log: LogDTO): Observable<any> {
    let url =
      this._configuration.ServerWithPlatformApiUrl + '/logs/' + log.identifier;
    return this._http
      .get(url, {
        headers: new HttpHeaders({
          Accept: '*/*'
        }),
        responseType: 'blob'
      })
      .pipe(
        tap((blob: Blob) => saveAs(blob, log.name + '.zip')),
        catchError(error => this.handleError(error))
      );
  }

  public getCSVFromService(url: string, fileName: string): Observable<any> {
    // let url =
    //   this._configuration.ServerWithPlatformApiUrl + '/logs/' + log.identifier;
    return this._http
      .get(url, {
        headers: new HttpHeaders({
          Accept: 'text/csv'
        }),
        responseType: 'blob'
      })
      .pipe(
        tap((blob: Blob) => saveAs(blob, fileName + '.csv')),
        catchError(error => this.handleError(error))
      );
  }

  public getTimers(): Observable<PaginationDTO<TimerDTO>> {
    let url = this._configuration.ServerWithPlatformApiUrl + '/timers/';
    return this._http
      .get<PaginationDTO<TimerDTO>>(url)
      .pipe(catchError(error => this.handleError(error)));
  }

  public updateTimerStatus(timer: TimerDTO, status?: boolean) {
    let serviceUrl =
      this._configuration.ServerWithPlatformApiUrl +
      '/timers/' +
      timer.identifier;

    timer.configurationStatus = status ? TimerStatusTypeDTO.STARTED : TimerStatusTypeDTO.STOPPED;

    return this._http
      .put(serviceUrl, JSON.stringify(timer))
      .pipe(catchError(error => this.handleError(error)));
  }

  public getSessions(): Observable<PaginationDTO<SessionDTO>> {
    let url = this._configuration.ServerWithUserApiUrl + '/sessioninfo';
    return this._http
      .get<PaginationDTO<SessionDTO>>(url)
      .pipe(catchError(error => this.handleError(error)));
  }

  public invalidateSession(
    userId: string,
    session: SessionDTO
  ): Observable<any> {
    let url =
      this._configuration.ServerWithUserApiUrl +
      '/actions?actionClasification=SESSION_USER';
    return this._http.get<PaginationDTO<ActionDefinitionDTO>>(url).pipe(
      switchMap((dto: PaginationDTO<ActionDefinitionDTO>) => {
        console.log('Accion recuperada ', dto.content[0]);
        let actionUrl =
          this._configuration.ServerWithUserApiUrl +
          '/users/' +
          userId +
          '/actions/' +
          dto.content[0].identifier +
          '?ID_SESSION=' +
          session.identifier;
        console.log('URL DE LA ACCION' + actionUrl);
        return this._http.get<any>(actionUrl);
      }),
      catchError(error => this.handleError(error))
    );
  }

  public getLicenses(
    activeLicense?: boolean
  ): Observable<PaginationDTO<LicenseDTO>> {
    let url = this._configuration.ServerWithUserApiUrl + 'licenses/';
    if (activeLicense) {
      url += '?active=true';
    }
    return this._http
      .get<PaginationDTO<LicenseDTO>>(url)
      .pipe(catchError(error => this.handleError(error)));
  }

  public getLicenseHostNameActive(): Observable<string> {
    let url = this._configuration.ServerWithUserApiUrl + 'licenses/hostName';

    return this.getAsText(url, null);
  }

  public getLicenseNumUsersActive(): Observable<string> {
    let url = this._configuration.ServerWithUserApiUrl + 'licenses/numUsersActive';

    return this.getAsText(url, null);
  }

  public getLicenseNumInvitsAllowed(): Observable<string> {
    let url = this._configuration.ServerWithUserApiUrl + 'licenses/numInvitsAllowed';

    return this.getAsText(url, null);
  }

  public setReceiveNotifications(activate?: boolean) {
    let serviceUrl =
      this._configuration.ServerWithUserApiUrl +
      'users/updateReceiveNotifications';
    let receive: ReceiveNotifsDTO = new ReceiveNotifsDTO();
    receive.receiveNotifications = activate;
    return this._http
      .put(serviceUrl, JSON.stringify(receive))
      .pipe(catchError(error => this.handleError(error)));
  }

  public getDossierRules(
    dossierId: string,
    divisionId?: string,
    showExecuted = false,
    showTerminated = false
  ): Observable<PaginationDTO<RuleDTO>> {
    let url =
      this._configuration.ServerWithUserApiUrl +
      'rules?dossierId=' +
      dossierId +
      '&refreshState=false';
    if (divisionId) {
      url += '&divisionId=' + divisionId;
    }

    if (showExecuted) {
      url += '&excludeExecuted=false';
    }
    if (showTerminated) {
      url += '&excludeTerminated=false';
    } else {
      url += '&excludeTerminated=true';
    }
    //    let url = 'assets/json/rules.json';
    return this._http
      .get<PaginationDTO<RuleDTO>>(url)
      .pipe(catchError(error => this.handleError(error)));
  }

  public getValidations = (validationGroup?: string): Observable<any> => {
    let url = this._configuration.ServerWithPlatformApiUrl + '/validations/';
    if (validationGroup) {
      url += validationGroup;
      //   url = url + 'Update';
      // } else {
      //   url = url + 'Insert';
    }
    return this._http
      .get<PaginationDTO<ValidationDTO>>(url)
      .pipe(catchError(error => this.handleError(error)));
  };

  public getCircuitos = (
    dossierId: string,
    divisionId: string,
    documentClassId: string,
    modeFilter?: CircuitFilterModeDTO,
    orderNumber?: number
  ): Observable<any> => {
    let url =
      this._configuration.ServerWithUserApiUrl +
      '/circuits?' +
      // 'page=0&size=10' +
      '&dossierId=' +
      dossierId +
      '&divisionId=' +
      divisionId +
      '&documentClassId=' +
      documentClassId;
    if (orderNumber >= 0) {
      url += '&orderNumber=' + orderNumber;
    }
    if (modeFilter) {
      url += '&modeFilter=' + modeFilter;
    } else {
      url += '&modeFilter=' + CircuitFilterModeDTO.Mandatory;
    }
    return this._http
      .get<PaginationDTO<CircuitoDTO>>(url)
      .pipe(catchError(error => this.handleError(error)));
  };

  // public getServiceErrorMessage(error: any): string {
  //   let msgErr: string;
  //   if (this.formService.isValidationResponse(error)) {
  //     // Iterar mensajes de errores
  //     let validationResponse = error as ValidationResultDTO;
  //     msgErr = '<div class="msgErrorValidacion">';
  //     if (validationResponse.errors.length > 1) {
  //       msgErr +=
  //         '<span>' +
  //         this.translationService.instant('ServerValidation.errorList.header') +
  //         '</span>';
  //       msgErr += '<ul>';
  //       validationResponse.errors.forEach(
  //         (validationError: ValidationExecutionDTO) => {
  //           const msg = this.getValidationExecutionMessage(validationError);
  //           msgErr += '<li>' + msg + '</li>';
  //         }
  //       );
  //       msgErr += '</ul></div>';
  //     } else {
  //       msgErr = this.getValidationExecutionMessage(
  //         validationResponse.errors[0]
  //       );
  //     }
  //   } else if (typeof error === 'string') {
  //     msgErr = error;
  //   } else if (error.message) {
  //     msgErr = error.message;
  //   } else {
  //     msgErr = JSON.stringify(error);
  //   }
  //   return msgErr;
  // }

  private getValidationExecutionMessage(
    validationError: ValidationExecutionDTO
  ) {
    return validationError.result === 'EXCEPTION'
      ? this.translationService.instant(
        'ServerValidation.errorList.exceptionMsg'
      )
      : validationError.message;
  }

  // METODOS CRUD genericos

  public query<T extends IObjectDTO<any>>(
    serviceUrl: string,
    parameters?:
      | HttpParams
      | {
        [param: string]: string | string[];
      }
  ): Observable<PaginationDTO<T>> {
    let options = {
      params: parameters
    };
    return this._http
      .get<PaginationDTO<T>>(this._configuration.URL_BASE + serviceUrl, options)
      .pipe(catchError(error => this.handleError(error)));
  }

  public ping(): Observable<any> {
    return this.get<any>(this._configuration.PROPERTY_SERVICE_URL, 'TRAZA')
      .pipe(catchError(error => this.handleError(error)));
  }

  public get<T extends IObjectDTO<any>>(
    serviceUrl: string,
    identifier: string,
    parameters?:
      | HttpParams
      | {
        [param: string]: string | string[];
      },
    responseType?: string
  ): Observable<T> {
    let url = this._configuration.URL_BASE + serviceUrl + identifier;
    let options = {
      params: parameters
    };
    if (responseType) {
      options['responseType'] = responseType;
    }
    return this._http
      .get<T>(url, options)
      .pipe(catchError(error => this.handleError(error)));
  }

  public simpleGet<T extends any>(
    serviceUrl: string,
    parameters?:
      | HttpParams
      | {
        [param: string]: string | string[];
      },
    responseType?: string
  ): Observable<T> {
    let url = this._configuration.URL_BASE + serviceUrl;
    let options = {
      params: parameters
    };
    if (responseType) {
      options['responseType'] = responseType;
    }
    return this._http
      .get<T>(url, options)
      .pipe(catchError(error => this.handleError(error)));
  }

  public put(serviceUrl: string) {
    let url = this._configuration.URL_BASE + serviceUrl;
    return this._http
      .put(url, undefined)
      .pipe(catchError(error => this.handleError(error)));
  }

  public validate<T extends IObjectDTO<any>>(
    serviceUrl: string,
    validation: string,
    object: T
  ): Observable<ValidationResultDTO> {
    let url =
      this._configuration.URL_BASE + serviceUrl + 'validations/' + validation;
    return this._http
      .put<ValidationResultDTO>(url, JSON.stringify(object, (k, v) => (k === '_parent' ? undefined : v)))
      .pipe(catchError(error => this.handleError(error)));
  }

  public simpleUpdate(
    serviceUrl: string,
    object: any,
  ): Observable<any> {
    let url = (serviceUrl.startsWith('http')) ? serviceUrl : this._configuration.URL_BASE + serviceUrl;
    return this._http
      .put(url, JSON.stringify(object))
      .pipe(catchError(error => this.handleError(error)));
  }

  public simplePost(
    serviceUrl: string,
    object: any,
  ): Observable<any> {
    let url = (serviceUrl.startsWith('http')) ? serviceUrl : this._configuration.URL_BASE + serviceUrl;
    return this._http
      .post(url, JSON.stringify(object))
      .pipe(catchError(error => this.handleError(error)));
  }

  public update<T extends IObjectDTO<any>>(
    serviceUrl: string,
    object: T,
    context?: string
  ): Observable<any> {
    let url =
      this._configuration.URL_BASE +
      (serviceUrl.endsWith('/') ? serviceUrl : serviceUrl + '/') +
      getSimpleIdentifierFromString(object.identifier);
    if (context) {
      if (object.context == null) {
        object.context = new ObjectContextDTO();
      }

      object.context.name = context;
    }
    return this._http
      .put(url, JSON.stringify(object, (k, v) => (k === '_parent' ? undefined : v)))
      .pipe(catchError(error => this.handleError(error)));
  }

  /**
   * Metodo de actualizacion que devuelve el objeto actualizado
   */
  public updateObject<T extends IObjectDTO<any>>(
    serviceUrl: string,
    object: T,
    context?: string,
    admitedErrorLevel?: ResultTypeDTO
  ): Observable<T> {
    // establecer nivel mínimo de validaciones que se permite para continuar
    if (!object.context) {
      object.context = new ObjectContextDTO();
    }
    object.context.severityLevel = (admitedErrorLevel) ? admitedErrorLevel : ResultTypeDTO.ERROR;
    let url =
      this._configuration.URL_BASE +
      (serviceUrl.endsWith('/') ? serviceUrl : serviceUrl + '/') +
      getSimpleIdentifierFromString(object.identifier);
    if (context) {
      if (object.context == null) {
        object.context = new ObjectContextDTO();
      }

      object.context.name = context;
    }
    return this._http
      .put(url, JSON.stringify(object, (k, v) => (k === '_parent' ? undefined : v)))
      .pipe(catchError(error => this.handleError(error)));
  }

  public patch<T extends IObjectDTO<any>>(
    serviceUrl: string,
    object: T,
    patchOperation?: string
  ): Observable<any> {
    let objectId =
      typeof object.identifier === 'string' &&
        object.identifier.indexOf('<>') > 0
        ? getSimpleIdentifierFromString(object.identifier)
        : object.identifier;
    let url =
      this._configuration.URL_BASE +
      (serviceUrl.endsWith('/') ? serviceUrl : serviceUrl + '/') +
      objectId +
      '?patch=true';
    if (patchOperation) {
      url += '&patchOperation=' + patchOperation;
    }
    return this._http
      .put(url, JSON.stringify(object, (k, v) => (k === '_parent' ? undefined : v)))
      .pipe(catchError(error => this.handleError(error)));
  }

  public insert<T extends IObjectDTO<any>>(
    serviceUrl: string,
    object: T,
    context?: string,
    admitedErrorLevel?: ResultTypeDTO
  ): Observable<T> {
    let url = this._configuration.URL_BASE + serviceUrl;
    if (context) {
      if (object.context == null) {
        object.context = new ObjectContextDTO();
      }
      object.context.name = context;
      if (!object.context) {
        object.context = new ObjectContextDTO();
      }
      object.context.severityLevel = (admitedErrorLevel) ? admitedErrorLevel : ResultTypeDTO.ERROR;
    }
    return this._http
      .post<T>(url, JSON.stringify(object, (k, v) => (k === '_parent' ? undefined : v)))
      .pipe(catchError(error => this.handleError(error)));
  }

  public delete<T extends IObjectDTO<any>>(
    serviceUrl: string,
    identifier: any,
    context?: string
  ): Observable<any> {
    let url =
      this._configuration.URL_BASE +
      (serviceUrl.endsWith('/') ? serviceUrl : serviceUrl + '/') +
      identifier;
    if (context) {
      url += '/contexts/' + context;
    }
    return this._http
      .delete<T>(url)
      .pipe(catchError(error => this.handleError(error)));
  }

  public execAction(
    serviceUrl: string,
    dtoId: any,
    actionId: any,
    parameters?: string
  ): Observable<any> {
    let options = {
      params: { id: actionId }
    };
    let url = this._configuration.URL_BASE + serviceUrl + dtoId + '/actions';
    return this._http
      .get<PaginationDTO<ActionDefinitionDTO>>(url, options)
      .pipe(
        flatMap((dto: PaginationDTO<ActionDefinitionDTO>) => {
          console.log('Accion recuperada ', dto.content[0]);
          let actionUrl =
            this._configuration.URL_BASE +
            serviceUrl +
            dtoId +
            '/actions/' +
            dto.content[0].identifier;
          console.log('URL DE LA ACCION' + actionUrl);

          if (parameters) {
            actionUrl += '?' + parameters;
          }
          return this._http.get<any>(actionUrl);
        }),
        catchError(error => this.handleError(error))
      );
  }

  // public getHelpContent(searchText: string) {
  //   return this._http
  //     .get<HelpDTO>(
  //       'assets/json/help/' + 'general_help.json' + '?searchText=' + searchText
  //     )
  //     .pipe(catchError(error => this.handleError(error)));
  // }

  public getJSON(jsonName: string) {
    return this._http
      .get<any>('assets/json/' + jsonName + '.json')
      .pipe(catchError(error => this.handleError(error)));
  }

  public getLastContractAproved = (
    contractFolderId: string,
    loteId: ContractLotDTO,
  ): Observable<ContractDTO> => {
    let url =
      this._configuration.URL_BASE + this._configuration.CONTRACTS_SERVICE_URL +
      'lastContractAproved?contractfolderid=' + contractFolderId;
    if (loteId !== undefined) {
      url = url + '&lotNumber=' + loteId.lot.lotNumber + '&description=' + loteId.lot.description;
    }
    return this._http
      .get<ContractDTO>(url)
      .pipe(catchError(error => this.handleError(error)));
  };


  public getOrganizationaUnitInfo = (
    organizationaUnitInfo: string
  ): Observable<ContractOrganizationalInfoDTO> => {
    let url =
      this._configuration.URL_BASE + this._configuration.CONTRACTS_SERVICE_URL +
      'organizationaUnitInfo?organizationalUnitId=' + organizationaUnitInfo;
    return this._http
      .get<ContractOrganizationalInfoDTO>(url)
      .pipe(catchError(error => this.handleError(error)));
  };

  public getDeadLines = (
    plannedPeriod: ContractPlannedPeriodDTO,
    contractFolderId: string,
    division: DivisionDTO,
  ): Observable<ContractPlannedPeriodDTO> => {


    let url =
      this._configuration.URL_BASE + this._configuration.CONTRACTS_SERVICE_URL +
      'deadLines?startDate=' + plannedPeriod.startDate.getTime() + '&contractFolderId=' + division.project.identifier
      + '&division=' + division.identifier;
    if (plannedPeriod.endDate !== undefined) {
      url += '&endDate=' + plannedPeriod.endDate.getTime()
    }
    return this._http
      .get<ContractPlannedPeriodDTO>(url)
      .pipe(catchError(error => this.handleError(error)));
  };

  public getExportProcess = (identifier): Observable<ExportProcessDTO> => {
    let url =
      this._configuration.URL_BASE + this._configuration.EXPORTPROCESS_SERVICE_URL + identifier;
    return this._http
      .get<ExportProcessDTO>(url)
      .pipe(catchError(error => this.handleError(error)));
  };

  public getExportProcesses = (filters: any): Observable<PaginationDTO<ExportProcessDTO>> => {
    let url =
      this._configuration.URL_BASE + this._configuration.EXPORTPROCESS_SERVICE_URL;
    if (filters) {
      if (filters['dateFrom']) {
        url += '&dateFrom=' + filters['dateFrom'].getTime()
      }
      if (filters['dateTo']) {
        url += '&dateTo=' + filters['dateTo'].getTime()
      }
      if (filters['user']) {
        url += '&user=' + filters['user'].identifier;
      }
    }
    return this._http
      .get<PaginationDTO<ExportProcessDTO>>(url)
      .pipe(catchError(error => this.handleError(error)));
  };

  public getExportProcessesConfigurations = (): Observable<any> => {
    let url =
      this._configuration.URL_BASE + this._configuration.EXPORTPROCESS_CONFIGURATIONS_SERVICE_URL;
    return this._http
      .get<ExportProcessConfigurationDTO>(url)
      .pipe(catchError(error => this.handleError(error)));
  };

  public createExportProcess = (
    exportProcess: ExportProcessDTO
  ): Observable<ExportProcessDTO> => {
    let url = this._configuration.URL_BASE + this._configuration.EXPORTPROCESS_SERVICE_URL
    return this._http
      .post<ExportProcessDTO>(url, JSON.stringify(exportProcess))
      .pipe(catchError(error => this.handleError(error)));
  }

  public downloadExportProcess = (exportProcess: ExportProcessDTO): any => {
    // "projectentityexportprocess/{id}/actions/downloadExportFile"
    let url =
      this._configuration.URL_BASE + this._configuration.EXPORTPROCESS_SERVICE_URL +
      exportProcess.identifier +
      '/actions/downloadExportFile'
      ;
    return this._http
      .get(url, {
        headers: new HttpHeaders({
          Accept: '*/*'
        }),
        responseType: 'blob'
      })
      .pipe(
        tap((blob: Blob) => saveAs(blob, exportProcess.name + '.zip')),
        catchError(error => this.handleError(error))
      );

  }

  public searchBudgetaryProject = (
    orderProject: OrderProjectDTO,
    url: string
  ): Observable<BugdetaryBreakdownDTO> => {
    return this._http
      .get<BugdetaryBreakdownDTO>(url)
      .pipe(catchError(error => this.handleError(error)));
  };

  public getDeadLinesGen = (
    plannedPeriod: OrderPlannedPeriodDTO,
    urlService: string
  ): Observable<OrderPlannedPeriodDTO> => {


    let url =
      this._configuration.URL_BASE + urlService +
      'deadLines?orderValidityFrom=' + plannedPeriod.orderValidityFrom.getTime();
    if (plannedPeriod.orderValidityUntil !== undefined) {
      url += '&orderValidityUntil=' + plannedPeriod.orderValidityUntil.getTime()
    }
    return this._http
      .get<OrderPlannedPeriodDTO>(url)
      .pipe(catchError(error => this.handleError(error)));
  };

  public documentService_requestCreatePreview(documentIdentifier: string): Observable<any> {
    let url = this._configuration.URL_BASE + this._configuration.DOCUMENTS_SERVICE_URL + documentIdentifier + '/requestCreatePreview';
    return this._http
      .put(url, {})
      .pipe(catchError(error => this.handleError(error)));
  }

  public documentService_downloadPreview(documentIdentifier: string): Observable<Blob> {
    let url = this._configuration.URL_BASE + this._configuration.DOCUMENTS_SERVICE_URL + documentIdentifier + '/downloadPreview';
    return this._http
      .get(url, {
        headers: new HttpHeaders({
          Accept: '*/*'
        }),
        responseType: 'blob'
      })
      .pipe(catchError(error => this.handleError(error)));
  }

  public reloadBudgetAccountLines = (
    entity: ContractDTO,
  ): Observable<any> => {


    let url =
      this._configuration.URL_BASE + this._configuration.CONTRACTS_SERVICE_URL +
      'reloadBudgetAccountLine';

    return this._http
      .put<ContractPlannedPeriodDTO>(url, JSON.stringify(entity))
      .pipe(catchError(error => this.handleError(error)));
  };

  public viewDocumentAudMessage(id: String, messageType: String, extension: String): Observable<PaginationDTO<AudMessageDTO>> {
    let url = this._configuration.ServerWithUserApiUrl + 'audMessage/' + id + '/viewDocument/' + messageType;

    // Si la extensión es null, establecerla en ".xml"
    if (extension === null) {
      extension = ".xml";
    }

    return this._http
      .get(url, {
        headers: new HttpHeaders({
          Accept: '*/*'
        }),
        responseType: 'blob'
      })
      .pipe(
        tap((blob: Blob) => saveAs(blob, id + '_' + messageType + extension)),
        catchError(error => this.handleError(error)));
  }
}
